import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";

// Reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import ModalHeader from "reactstrap/lib/ModalHeader";

// componente
import ModalJustificativa from "components/ModalJustificativa/ModalJustificativa";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";

// style
import "assets/css/map.css";
import {
  table_translate,
  table_style,
} from "../../../constants/MaterialTable.js";

// helpers
import { formateDate, formateDateandTime } from "../../../helpers/formats";

// services
import { api_GET, api_POST } from "../../../services/api_service.js";
import { showMessage, showQuestion } from "../../../services/message.js";
import { CancelarRequerimentoByRequerimento } from "../../../services/requerimento_service.js";

// views
import FichaRequerimento from "../../../views/Shared/Gerador/FichaRequerimento";

//Context
import { useAuth } from "../../../context/auth";

export default function FichaGerador({ history, item, showAcoesGestor }) {
  const { session, setLoading, signOut, setupSistema } = useAuth();

  const [protocolo, set_protocolo] = useState(null);

  const [list_acoes, set_list_acoes] = useState(null);

  const [requerimento, set_requerimento] = useState(null);

  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  //State para modal do contrato
  const [modalContrato, set_modalContrato] = useState(false);

  //State Para adicionar os contratos em cada local
  const [listContratoLocal, set_listcontratoLocal] = useState([]);

  const toggleModalContrato = () => set_modalContrato(!modalContrato);

  const [segmentoGerador, setSegmentoGerador] = useState(null);

  // Mapa
  const [modalMapaOpen, set_modalMapaOpen] = useState(false);
  const [centerMap, setCenterMap] = useState([0, 0]);
  const [positionMarker, setpositionMarker] = useState([0, 0]);
  const iconMarker = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
    iconRetinaUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
  });
  const ChangeMap = ({ center, zoom }) => {
    const mapInstance = useMap();
    mapInstance.setView(center, zoom);
    return null;
  };
  const handleModalOpen = (geoLocalizacao) => {
    if (geoLocalizacao && geoLocalizacao.split(";").length > 1) {
      setCenterMap([
        geoLocalizacao.split(";")[0],
        geoLocalizacao.split(";")[1],
      ]);
      setpositionMarker([
        geoLocalizacao.split(";")[0],
        geoLocalizacao.split(";")[1],
      ]);
      set_modalMapaOpen(true);
    }
  };

  const loadOptionsAcoes = () => {
    api_GET("SetupSolicitacao/GetListByProtocolo/" + item.numeroProtocolo)
      .then((result) => set_list_acoes(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleOpenRequerimento = (rowData) => {
    if (
      (rowData.status == "Em Andamento" || rowData.status == "Divergente") &&
      showAcoesGestor == false
    ) {
      switch (rowData.setupSolicitacaoAcao.acao) {
        case "Novo Cadastro": {
          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RCC" ||
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RGG"
          )
            window.location =
              "/auth/GeradorRequerimento?protocolo=" +
              protocolo.numeroProtocolo;
          else
            window.location =
              "/auth/GeradorRSSRequerimento?protocolo=" +
              protocolo.numeroProtocolo;
          break;
        }
        case "Renovação":
          if (
            (rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
              "RCC" && rowData.setupSolicitacaoAcao.setupSolicitacao.segmento !== "Grande Gerador - PGRCC") ||
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RGG"
          ) {
            history.push({
              pathname: "/auth/GeradorRequerimentoRenovacao",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          if (rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RCC" &&
            rowData.setupSolicitacaoAcao.setupSolicitacao.segmento === "Grande Gerador - PGRCC") {
            history.push({
              pathname: "/auth/GeradorPGRCCRequerimentoRenovacaoCadastro",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          break;
        case "Inclusão":
          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RCC" ||
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RGG"
          ) {
            history.push({
              pathname: "/auth/GeradorRequerimentoInclusaoLocal",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          break;
        case "Exclusão":
          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RCC" ||
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RGG"
          ) {
            history.push({
              pathname: "/auth/GeradorRequerimentoExclusaoLocal",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          break;
        case "Cancelamento":
          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RCC" ||
            rowData.setupSolicitacaoAcao.setupSolicitacao.segmento === "Grande Gerador - PGRCC" ||
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG"
          ) {
            history.push({
              pathname: "/auth/RequerimentoCancelamento",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          break;
        case "Alteração":
          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RSS"
          ) {
            history.push({
              pathname: "/auth/GeradorRSSRequerimentoAlteracao",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }

          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RGG" ||
            (rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
              "RCC" && rowData.setupSolicitacaoAcao.setupSolicitacao.segmento !== "Grande Gerador - PGRCC")
          ) {
            history.push({
              pathname: "/auth/GeradorRequerimentoAlteracaoCadastro",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }

          if (rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RCC" && rowData.setupSolicitacaoAcao.setupSolicitacao.segmento === "Grande Gerador - PGRCC") {
            history.push({
              pathname: "/auth/GeradorPGRCCRequerimentoAlteracaoCadastro",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          break;
        case "Taxa FisLurb":
          if (
            rowData.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
            "RSS"
          ) {
            history.push({
              pathname: "/auth/RequerimentoTaxaFislurb",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
                requerimento: rowData,
              },
            });
          }
          break;
        default:
          break;
      }
    } else {
      setLoading(true);
      api_GET("requerimento/" + rowData.requerimento_Id)
        .then((result) => set_requerimento(result.data))
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }
  };

  const handleAtualizarContato = () => {
    history.push({
      pathname: "/auth/AtualizarContato",
      state: { protocolo: protocolo },
    });
  };

  const handleRequerimentoRenovarCadastro = (setupSolicitacaoAcao) => {
    if (setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RSS") {
      showMessage("Aviso", "Este tipo de requerimento não pode ser realizado para Geradores de Resíduos de Serviço de Saúde", "error", null);
      return;
    }

    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }

    showQuestion(
      "Atenção",
      "Quer criar um requerimento de renovação de cadastro?",
      "question",
      function (result) {
        if (result) {
          if (!!segmentoGerador && segmentoGerador === "Grande Gerador - PGRCC") {
            history.push({
              pathname: "/auth/GeradorPGRCCRequerimentoRenovacaoCadastro",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: setupSolicitacaoAcao,
              },
            });
          } else {
            history.push({
              pathname: "/auth/GeradorRequerimentoRenovacao",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: setupSolicitacaoAcao,
              },
            });
          }
        }
      }
    );
  };

  const handleRequerimentoAlterarCadastro = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion(
      "Atenção",
      "Quer criar um requerimento de alteração de cadastro?",
      "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/GeradorRSSRequerimentoAlteracao",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoTaxaFislurb = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.filter((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao == "Taxa FisLurb").length > 0) {
      showMessage("Aviso", "Você já possui um Requerimento de Taxa FisLurb em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de taxa fislurb?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/RequerimentoTaxaFislurb",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  }

  const handleRequerimentoAlterarCadastroRCC_RGG = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion(
      "Atenção",
      "Quer criar um requerimento de alteração de cadastro?",
      "question",
      function (result) {
        if (result) {
          if (!!segmentoGerador && segmentoGerador === "Grande Gerador - PGRCC") {
            history.push({
              pathname: "/auth/GeradorPGRCCRequerimentoAlteracaoCadastro",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: setupSolicitacaoAcao,
              },
            });
          } else {
            history.push({
              pathname: "/auth/GeradorRequerimentoAlteracaoCadastro",
              state: {
                protocolo: protocolo,
                setupSolicitacaoAcao: setupSolicitacaoAcao,
              },
            });
          }
        }
      }
    );
  };

  const handleRequerimentoCancelamento = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de cancelamento de cadastro?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/RequerimentoCancelamento",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoInclusaoLocalColeta = (setupSolicitacaoAcao) => {
    if (setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RSS") {
      showMessage(
        "Aviso",
        "Este tipo de requerimento não pode ser realizado para Geradores de Resíduos de Serviço de Saúde",
        "error",
        null
      );
      return;
    }

    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage(
        "Aviso",
        "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!",
        "error",
        null
      );
      return;
    }
    showQuestion(
      "Atenção",
      "Quer criar um requerimento de inclusão de local de coleta?",
      "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/GeradorRequerimentoInclusaoLocal",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoExclusaoLocalColeta = (setupSolicitacaoAcao) => {
    if (setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RSS") {
      showMessage(
        "Aviso",
        "Este tipo de requerimento não pode ser realizado para Geradores de Resíduos de Serviço de Saúde",
        "error",
        null
      );
      return;
    }

    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de exclusão de local de coleta?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/GeradorRequerimentoExclusaoLocal",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleCancelarRequerimento = (_requerimento) => {
    showQuestion("Atenção", "Quer cancelar este requerimento?", "question",
      function (result) {
        if (result) {
          let usuario_Id =
            session != null && session.tipoAcesso == "AreaRestrita"
              ? session.usuario_Id
              : 0;
          setLoading(true);
          CancelarRequerimentoByRequerimento(
            _requerimento.requerimento_Id,
            usuario_Id,
            handleRetornoCancelaRequerimento
          );
        }
      }
    );
  };
  const handleRetornoCancelaRequerimento = (result) => {
    setLoading(false);
    showMessage(
      "Aviso",
      "Requerimento cancelado com sucesso!",
      "success",
      function () {
        window.location.reload();
      }
    );
  };

  const handleRequerimentoNovoCadastro = (setupSolicitacaoAcao) => {
    showQuestion(
      "Atenção",
      "Deseja criar requerimento de Novo Cadastro?",
      "question",
      function (result) {
        if (result) {
          setLoading(true);

          api_POST(
            `requerimento/PostNovoRequerimento/${protocolo.protocolo_Id}`
          )
            .then((result) => {
              showMessage(
                "Aviso",
                "Requerimento criado com sucesso! Preencha seus dados na tela seguinte.",
                "success",
                function () {
                  if (
                    setupSolicitacaoAcao.setupSolicitacao.categoria.sigla ==
                    "RSS"
                  )
                    window.location.href = `/auth/GeradorRSSRequerimento?protocolo=${protocolo.numeroProtocolo}`;
                  else
                    window.location.href = `/auth/GeradorRequerimento?protocolo=${protocolo.numeroProtocolo}`;
                }
              );
            })
            .catch((err) => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
        }
      }
    );
  };

  const openArquivoContrata = (rowData) => {
    const linkSource = `data:application/pdf;base64,${rowData.arquivoContrato}`;
    const downloadLink = document.createElement("a");
    const fileName = "ContratoLocal.pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleReturnRequerimento = () => {
    set_requerimento(null);
  };

  const handleEmitirGuia = (requerimento_Id) => {
    let json_submit = {
      requerimento_Id: requerimento_Id,
      usuarioEmissao_Id: null,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoCobranca", json_submit)
      .then((result) =>
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          window.location.reload()
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    set_protocolo(item);
    setSegmentoGerador(
      item?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria
        ?.segmento
    );

    loadOptionsAcoes();
  }, [item]);

  if (
    protocolo !== null &&
    protocolo.requerimento.length > 0 &&
    (session == null || (session && session.tipoAcesso === "Protocolo"))
  ) {
    const result = protocolo.requerimento.filter(
      (x) =>
        x.fluxoCadastroEtapaAtual !== null &&
        x.fluxoCadastroEtapaAtual.descricao === "Aguardando Compensação" &&
        x.setupSolicitacaoAcao.valorGuia > 0
    );
    if (result.length > 0) {
      showMessage(
        "Aviso",
        `Os pagamentos dos boletos não devem ser efetuados via Bancos Digitais, pois o Sistema da Prefeitura não reconhece esses pagamentos, e assim o cadastro não será liberado!
              Por favor, efetuar os pagamentos pelos bancos: Banco do Brasil, Bancoob, Banco Inter, Banco Original, Bradesco, Caixa, Daycoval, Itaú, Correspondentes Bancários, Rendimento, Safra, Santander.`,
        "warning",
        null
      );
    }
  }

  return (
    <>
      <div className="row">
        {session && session.tipoAcesso == "Protocolo" && (
          <div className="col-4 col-lg-4 text-start">
            <Button
              color="warning"
              onClick={() => {
                signOut(false, () => {
                  window.location.href = "/auth/meucadastro";
                });
              }}
            >
              <i class="fas fa-sign-out-alt"></i> Sair
            </Button>
          </div>
        )}
        {!showAcoesGestor && (
          <div className="col-8 col-lg-8 text-right">
            <Button color="info" onClick={() => handleAtualizarContato()}>
              <i class="fas fa-user"></i> Atualizar Contato
            </Button>
          </div>
        )}
      </div>
      <Modal
        centered
        isOpen={modalContrato}
        toggle={toggleModalContrato}
        size={"xl"}
        style={{ marginTop: "70px" }}
      >
        <ModalBody className="md-bd">
          <ModalHeader
            toggle={toggleModalContrato}
            className="p-0 mb-2"
            style={{ borderBottom: "none" }}
            close={<></>}
          >
            Contratos
          </ModalHeader>
          <Row>
            <Col md="12">
              <MaterialTable
                style={{ minHeight: "auto" }}
                title={""}
                columns={[
                  { title: "Modalidade", field: "modalidadeColeta" },
                  { title: "CNPJ", field: "transportador_CNPJ" },
                  { title: "Razão Social", field: "transportador_RazaoSocial" },
                  {
                    title: "Status Regularidade",
                    field: "statusRegularidade",
                    render: (rowData) =>
                      rowData.statusRegularidade
                        ? rowData.statusRegularidade
                        : "Regular",
                  },
                ]}
                data={listContratoLocal}
                actions={[
                  {
                    icon: "download",
                    tooltip: "Fazer download",
                    onClick: (event, rowData) =>
                      window.open(
                        setupSistema?.caminhoVirtual + rowData.arquivoContrato,
                        "_blank"
                      ),
                  },
                ]}
                isLoading={false}
                localization={table_translate}
                options={table_style}
              />
            </Col>
          </Row>
          <Row>
            <Col md="12" className="d-flex justify-content-center">
              <Button
                className="text-center"
                color={"dark"}
                onClick={toggleModalContrato}
              >
                Fechar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      {protocolo != null && requerimento == null && (
        <div>
          <Card>
            {protocolo?.requerimento?.filter(x =>
              x.fluxoCadastroEtapaAtual?.tipo == "Aguardando Aprovação de Guia" &&
              x.status === "Pendente" &&
              x.requerimentoTaxaFislurb != null &&
              x.requerimentoTaxaFislurb.some(rtf =>
                rtf.requerimentoTaxaFislurbBoletos.some(b => !!b.guiaArrecadacao && !b.DataPagamento)
              )
            ).length > 0 &&
              <Row>
                <Col lg="12">
                  <p className="text-danger">Guia da Taxa Fislurb disponível para pagamento</p>
                </Col>
              </Row>
            }

            <CardBody>
              {protocolo.status != "Ativo" && (
                <Row>
                  <Col lg="12">
                    <h5 className="text-danger">
                      * Cadastro {protocolo.status} no sistema
                    </h5>
                  </Col>
                </Row>
              )}
              {protocolo.protocoloGerador[0]?.protocoloGeradorLocais?.some(
                (local) =>
                  local.protocoloGeradorLocalContratos?.some(
                    (contrato) => contrato.statusRegularidade === "Irregular"
                  )
              ) && (
                  <Row>
                    <Col lg="12">
                      <h5 className="text-danger">
                        * Contratos de Locais de Coletas com Irregularidades
                      </h5>
                    </Col>
                  </Row>
                )}
              <Row className="text-center">
                <Col lg="12">
                  <h2 className="titulo-solicitacao">
                    {
                      protocolo.setupSolicitacaoAcaoNovoCadastro
                        .setupSolicitacao.categoria.descricao
                    }
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Empresa</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>
              <Row>
                <Col lg="6" sm="12">
                  <p>
                    <b>Fantasia:</b>{" "}
                    {protocolo.protocoloGerador[0]?.nome_Fantasia}
                  </p>
                </Col>
                <Col className="text-mobile" lg="6" sm="12">
                  <p>
                    <b>CNPJ/CPF:</b> {protocolo.cpf_Cnpj}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Razão Social:</b>{" "}
                    {protocolo.protocoloGerador[0]?.razaoSocial}
                  </p>
                </Col>
                <Col lg="2" sm="12">
                  <p>
                    <b>CCM:</b> {protocolo.protocoloGerador[0]?.ccm}
                  </p>
                </Col>
                <Col lg="4" sm="12">
                  <p>
                    <b>Número Cadastro:</b> {protocolo?.codigoCadastro}
                  </p>
                </Col>
                <Col lg="4" sm="12">
                  <p>
                    <b>Ramo:</b> {protocolo.protocoloGerador[0]?.ramoAtividade}
                  </p>
                </Col>
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla !== "RGG" && (
                    <Col lg="4" sm="12">
                      <p>
                        <b>Tipo de Indústria / Coméricio:</b>{" "}
                        {protocolo.protocoloGerador[0]?.tipoIndustriaComercio}
                      </p>
                    </Col>
                  )}
                <Col lg="2" sm="12">
                  <p>
                    <b>CEP:</b> {protocolo.protocoloGerador[0]?.cep}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Endereço:</b>{" "}
                    {protocolo.protocoloGerador[0]?.logradouro +
                      ", " +
                      protocolo.protocoloGerador[0]?.numEndereco +
                      ", " +
                      protocolo.protocoloGerador[0]?.complemento}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Bairro:</b> {protocolo.protocoloGerador[0]?.bairro}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Cidade:</b> {protocolo.protocoloGerador[0]?.cidade}
                  </p>
                </Col>
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla !== "RSS" && (
                    <Col lg="6" sm="12">
                      <p>
                        <b>Fim da Vigência:</b>{" "}
                        {protocolo.dataFimVigencia != null
                          ? formateDate(protocolo.dataFimVigencia)
                          : ""}
                      </p>
                    </Col>
                  )}
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla == "RSS" && (
                    <Col lg="12" sm="12">
                      <p>
                        <b>Tipo Estabelecimento:</b>{" "}
                        {protocolo.protocoloGerador[0]?.tipoEstabelecimento != null
                          ? protocolo.protocoloGerador[0]?.tipoEstabelecimento
                            .descricao
                          : ""}
                      </p>
                    </Col>
                  )}
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla == "RSS" &&
                  protocolo.protocoloGerador[0]?.tipoEstabelecimento != null &&
                  protocolo.protocoloGerador[0]?.tipoEstabelecimento.descricao ==
                  "HOSPITAL" && (
                    <Col lg="6" sm="12">
                      <p>
                        <b>Quantidade Leitos Ativos:</b>{" "}
                        {protocolo.protocoloGerador[0]?.quantidadeLeitosAtivos}
                      </p>
                    </Col>
                  )}
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla == "RSS" &&
                  protocolo.protocoloGerador[0]?.tipoEstabelecimento != null &&
                  protocolo.protocoloGerador[0]?.tipoEstabelecimento.descricao ==
                  "HOSPITAL" && (
                    <Col lg="6" sm="12">
                      <p>
                        <b>Quantidade Leitos Inativos:</b>{" "}
                        {protocolo.protocoloGerador[0]?.quantidadeLeitosInativos}
                      </p>
                    </Col>
                  )}
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla == "RSS" && (
                    <Col lg="12" sm="12">
                      <p>
                        <b>Classificação Estabelecimento:</b>{" "}
                        {protocolo.protocoloGerador[0]
                          ?.classificacaoEstabelecimento != null
                          ? protocolo.protocoloGerador[0]
                            ?.classificacaoEstabelecimento.descricao
                          : ""}
                      </p>
                    </Col>
                  )}
                {protocolo != null &&
                  protocolo.status !== "Pendente" &&
                  !!segmentoGerador &&
                  segmentoGerador !== "Grande Gerador - PGRCC" &&
                  (protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                    .categoria.sigla === "RCC" ||
                    protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                      .categoria.sigla === "RGG") && (
                    <>
                      <Col md="2">
                        <b>Carteirinha</b>
                        <br />
                        <i
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            window.open(
                              "/empty/CarteirinhaGG?protocolo=" +
                              protocolo.numeroProtocolo,
                              "_blank"
                            )
                          }
                          className="fas fa-qrcode fa-2x text-info"
                        ></i>
                      </Col>
                      {protocolo.setupSolicitacaoAcaoNovoCadastro
                        .setupSolicitacao.categoria.sigla == "RGG" && (
                          <Col md="2">
                            <b>QRCodes Coleta</b>
                            <br />
                            <i
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                window.open(
                                  "/empty/QrCodelocalidadeRGG?protocolo=" +
                                  protocolo.numeroProtocolo,
                                  "_blank"
                                )
                              }
                              className="fas fa-qrcode fa-2x text-info"
                            ></i>
                          </Col>
                        )}
                    </>
                  )}
                {protocolo != null &&
                  protocolo.status != "Pendente" &&
                  protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                    .categoria.sigla == "RSS" && (
                    <Col md="12" className="text-center">
                      <b>Certificado</b>
                      <br />
                      <i
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          window.open(
                            "/empty/CertificadoRSS?protocolo=" +
                            protocolo.numeroProtocolo,
                            "_blank"
                          )
                        }
                        className="fas fa-qrcode fa-2x text-info"
                      ></i>
                    </Col>
                  )}
              </Row>

              {protocolo != null &&
                protocolo.status != "Pendente" &&
                protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla == "RGG" &&
                protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.segmento == "Grande Gerador" && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Dados Adicionais</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Número de Colaboradores:</b>{" "}
                        {protocolo.protocoloGerador[0]?.numeroColaboradores ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Consumo mensal de Energia:</b>{" "}
                        {protocolo.protocoloGerador[0]?.consumoMensalAgua ?? ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Consumo Mensal de Água:</b>{" "}
                        {protocolo.protocoloGerador[0]?.consumoMensalAgua ?? ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Local do Empreendimento:</b>{" "}
                        {protocolo.protocoloGerador[0]?.localEmpreendimento ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Área total (m²):</b>{" "}
                        {protocolo.protocoloGerador[0]?.areaTotal
                          ?.toString()
                          ?.replace(".", ",") ?? ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Área Construída (m²):</b>{" "}
                        {protocolo.protocoloGerador[0]?.areaConstruida
                          ?.toString()
                          ?.replace(".", ",") ?? ""}
                      </p>
                    </Col>
                  </Row>
                )}

              {
                protocolo != null &&
                protocolo.status != "Pendente" &&
                protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.segmento === "Grande Gerador - PGRCC" && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Responsável Técnico Pelo Projeto</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>CPF do Responsável:</b>{" "}
                        {protocolo.protocoloGerador[0]?.cpfResponsavel ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Função do Reponsável:</b>{" "}
                        {protocolo.protocoloGerador[0]?.funcaoResponsavel ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Departamento do Reponsável:</b>{" "}
                        {protocolo.protocoloGerador[0]?.departamentoResponsavel ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Código CNAE:</b>{" "}
                        {protocolo.protocoloGerador[0]?.codigoCNAE ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Atividade CNA:</b>{" "}
                        {protocolo.protocoloGerador[0]?.atividadeCNA ??
                          ""}
                      </p>
                    </Col>
                  </Row>
                )
              }

              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Responsável</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>

              <Row>
                <Col lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>
                    {protocolo.protocoloGerador[0]?.nomeResponsavel}
                  </h6>
                </Col>
                <Col className="text-mobile" lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>{protocolo.email}</h6>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Telefone:</b> {protocolo.protocoloGerador[0]?.telefone}
                  </p>
                </Col>
                <Col lg="6" className="text-mobile" sm="12">
                  <p>
                    <b>Celular:</b> {protocolo.protocoloGerador[0]?.celular}
                  </p>
                </Col>
              </Row>



              {/* Grande Gerador - PGRCC */}
              {protocolo?.protocoloGerador[0] &&
                protocolo?.protocoloGerador[0]?.protocoloGeradorObras?.length >
                0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">Dados da Obra</h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Empreendimento:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.empreendimento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Razão Social:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.razaoSocial
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Nome Fantasia:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.fantasia
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CNPJ:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.cnpj
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Telefone:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.telefone
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Email:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.email
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Contato:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.contato
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CEP:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.cep
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Logradouro:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.logradouro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Número:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.numero
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Complemento:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.complemento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Bairro:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.bairro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Cidade:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.cidade
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>UF:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.uf
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Área Construir:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.areaConstruir
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Área Demolir:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.areaDemolir
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Volume Receber:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.volumeReceber
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Volume Destinar:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.volumeDestinar
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Tipo Empreendimento:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.tipoEmpreendimento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Tipo Construção:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.tipoConstrucao
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Tipologia:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.tipologia
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Práticas de Reciclagem:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.praticasDeReciclagem
                        }
                      </Col>
                      <Col lg="12" className="mb-2">
                        <b>Descrição do Empreendimento:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]
                            ?.descricaoEmpreendimento
                        }
                      </Col>
                      <Col lg="12" className="mb-2">
                        <b>Outras Informações:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorObras?.[0]?.outrasInformacoes
                        }
                      </Col>
                    </Row>
                  </>
                )}

              {protocolo?.protocoloGerador[0] &&
                protocolo?.protocoloGerador[0]?.protocoloGeradorExecutorObras
                  ?.length > 0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">
                          Dados do Executor da Obra
                        </h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CPF/CNPJ:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.cpf_Cnpj
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Razão Social:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.razaoSocial
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Nome Fantasia:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.fantasia
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Telefone:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.telefone
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Email:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.email
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>Representante Legal:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.representanteLegal
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CPF Representante:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.cpfRepresentante
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Função Representante:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.funcaoRepresentante
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Departamento Representante:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.departamentoRepresentante
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>Código CNAE:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.codigoCNAE
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Atividade CNA:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.atividadeCNA
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>CEP:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.cep
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Logradouro:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.logradouro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Número:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.numero
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Complemento:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.complemento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Bairro:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.bairro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Cidade:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.cidade
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>UF:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]?.uf
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>Nome Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.nomeResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CPF Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.cpfResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CREA Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.creaResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Função Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.funcaoResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Departamento Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.departamentoResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Telefone Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.telefoneResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Email Responsável Técnico:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorExecutorObras?.[0]
                            ?.emailResponsavelTecnico
                        }
                      </Col>
                    </Row>
                  </>
                )}

              {protocolo?.protocoloGerador?.[0] &&
                protocolo?.protocoloGerador?.[0]
                  ?.protocoloGeradorModeloPlanoResiduos?.length > 0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">
                          Modelo do Plano Resíduo
                        </h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Modelo:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorModeloPlanoResiduos?.[0]?.modelo
                        }
                      </Col>
                      <Col lg="12" className="mb-2">
                        <b>Descrição:</b>{" "}
                        {
                          protocolo?.protocoloGerador?.[0]
                            ?.protocoloGeradorModeloPlanoResiduos?.[0]
                            ?.descricao
                        }
                      </Col>
                      {protocolo?.protocoloGerador?.[0]
                        ?.protocoloGeradorModeloPlanoResiduos?.[0]
                        ?.preExecucaoDe && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pré Execução De:</b>{" "}
                            {new Date(
                              protocolo.protocoloGerador[0]?.protocoloGeradorModeloPlanoResiduos[0]?.preExecucaoDe
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {protocolo?.protocoloGerador?.[0]
                        ?.protocoloGeradorModeloPlanoResiduos?.[0]
                        ?.preExecucaoAte && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pré Execução Até:</b>{" "}
                            {new Date(
                              protocolo.protocoloGerador[0]?.protocoloGeradorModeloPlanoResiduos[0]?.preExecucaoAte
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {protocolo?.protocoloGerador?.[0]
                        ?.protocoloGeradorModeloPlanoResiduos?.[0]
                        ?.execucaoDe && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Execução De:</b>{" "}
                            {new Date(
                              protocolo.protocoloGerador[0]?.protocoloGeradorModeloPlanoResiduos[0]?.execucaoDe
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {protocolo?.protocoloGerador?.[0]
                        ?.protocoloGeradorModeloPlanoResiduos?.[0]
                        ?.execucaoAte && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Execução Até:</b>{" "}
                            {new Date(
                              protocolo.protocoloGerador[0]?.protocoloGeradorModeloPlanoResiduos[0]?.execucaoAte
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {protocolo?.protocoloGerador?.[0]
                        ?.protocoloGeradorModeloPlanoResiduos?.[0]
                        ?.posExecucaoDe && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pós Execução De:</b>{" "}
                            {new Date(
                              protocolo.protocoloGerador[0]?.protocoloGeradorModeloPlanoResiduos[0]?.posExecucaoDe
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {protocolo?.protocoloGerador?.[0]
                        ?.protocoloGeradorModeloPlanoResiduos?.[0]
                        ?.posExecucaoAte && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pós Execução Até:</b>{" "}
                            {new Date(
                              protocolo.protocoloGerador[0]?.protocoloGeradorModeloPlanoResiduos[0]?.posExecucaoAte
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                    </Row>
                  </>
                )}

              {protocolo?.protocoloGerador?.[0] &&
                protocolo?.protocoloGerador?.[0]
                  ?.protocoloGeradorDetalhamentoPlanoResiduos?.length > 0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">
                          Detalhamento do Plano Resíduo
                        </h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <MaterialTable
                      style={{ minHeight: "auto", width: "100%" }}
                      title=""
                      columns={[
                        { title: "Fase", field: "fase" },
                        { title: "Detalhamento", field: "detalhamento" },
                        {
                          title: "Descrição",
                          field: "descricao",
                        },
                        { title: "Volume por Mês (m³)", field: "volumeMes" },
                        {
                          title: "Armazenamento na Obra",
                          field: "armazenamentoObra",
                        },
                        {
                          title: "Tipo de Destinação",
                          field: "tipoDestinacao",
                        },
                      ]}
                      data={
                        protocolo?.protocoloGerador?.[0]
                          ?.protocoloGeradorDetalhamentoPlanoResiduos
                      }
                      isLoading={false}
                      options={{
                        filtering: false,
                        exportButton: true,
                      }}
                      localization={table_translate}
                    />
                  </>
                )}

              {protocolo?.protocoloGerador?.[0] &&
                protocolo?.protocoloGerador?.[0]?.protocoloGeradorDestinosPGRCC
                  ?.length > 0 && (
                  <>
                    <Row className="mt-4">
                      <Col lg="12">
                        <h3 className="titulo-consulta">Destinos</h3>
                        <div className="line-protocolo"></div>
                      </Col>

                      <MaterialTable
                        style={{ minHeight: "auto", width: "100%" }}
                        title=""
                        columns={[
                          { title: "CNPJ do Destino", field: "cnpjDestino" },
                        ]}
                        data={
                          protocolo?.protocoloGerador[0]
                            .protocoloGeradorDestinosPGRCC
                        }
                        isLoading={false}
                        options={{
                          filtering: false,
                          exportButton: true,
                        }}
                        localization={table_translate}
                      />
                    </Row>
                  </>
                )}

              {protocolo?.protocoloGerador?.[0] &&
                protocolo?.protocoloGerador?.[0]
                  ?.protocoloGeradorTransportadoresPGRCC?.length > 0 && (
                  <>
                    <Row className="mt-4">
                      <Col lg="12">
                        <h3 className="titulo-consulta">Transportadores</h3>
                        <div className="line-protocolo"></div>
                      </Col>

                      <MaterialTable
                        style={{ minHeight: "auto", width: "100%" }}
                        title=""
                        columns={[
                          {
                            title: "CNPJ do Transportador",
                            field: "cnpjTransportador",
                          },
                        ]}
                        data={
                          protocolo?.protocoloGerador[0]
                            .protocoloGeradorTransportadoresPGRCC
                        }
                        isLoading={false}
                        options={{
                          filtering: false,
                          exportButton: true,
                        }}
                        localization={table_translate}
                      />
                    </Row>
                  </>
                )}

              {/* ----------------------- */}

              {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                .categoria.sigla === "RSS" && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">Responsável Técnico</h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" sm="12">
                        <h6 style={{ paddingTop: "5px" }}>
                          {protocolo.protocoloGerador[0]?.nomeResponsavelTecnico}
                        </h6>
                      </Col>
                      <Col lg="4" sm="12">
                        <p>
                          <b>Tipo Documento:</b>{" "}
                          {
                            protocolo.protocoloGerador[0]?.tipoDocumentoResponsavelTecnico
                          }
                        </p>
                      </Col>
                      <Col lg="4" sm="12">
                        <p>
                          <b>Número Documento:</b>{" "}
                          {
                            protocolo.protocoloGerador[0]?.numeroDocumentoResponsavelTecnico
                          }
                        </p>
                      </Col>
                      <Col lg="4" sm="12">
                        {protocolo.protocoloGerador[0]?.arquivoCertificadoResponsavelTecnico != null && (
                          <a
                            href={
                              setupSistema?.caminhoVirtual +
                              protocolo.protocoloGerador[0]?.arquivoCertificadoResponsavelTecnico
                            }
                            target="_blank"
                          >
                            Certificado Curso
                          </a>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

              {protocolo.protocoloGerador[0]?.protocoloGeradorCaracterizacaoResiduos != null &&
                protocolo.protocoloGerador[0]?.protocoloGeradorCaracterizacaoResiduos.length > 0 && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">
                        Caracterização dos Resíduos
                      </h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      <Row md="12">
                        {protocolo.protocoloGerador[0]?.protocoloGeradorCaracterizacaoResiduos.filter(
                          (x) => !!x.caracterizacaoResiduosConama.grupo
                        ).length > 0 && (
                            <Col md="1">
                              <b>Grupo</b>
                            </Col>
                          )}
                        <Col
                          md={
                            protocolo.protocoloGerador[0]?.protocoloGeradorCaracterizacaoResiduos.filter((x) => !!x.caracterizacaoResiduosConama.grupo
                            ).length > 0
                              ? "1"
                              : "2"
                          }
                        >
                          <b>Código</b>
                        </Col>
                        {protocolo.protocoloGerador[0]?.protocoloGeradorCaracterizacaoResiduos.filter(
                          (x) => !!x.caracterizacaoResiduosConama?.tipo
                        ).length > 0 && (
                            <Col md="1">
                              <b>Tipo</b>
                            </Col>
                          )}
                        <Col md="7">
                          <b>Descrição</b>
                        </Col>
                        <Col md="2">
                          <b>Quantidade</b>
                        </Col>
                      </Row>
                      {protocolo.protocoloGerador[0]?.protocoloGeradorCaracterizacaoResiduos.map(
                        (item, key) => (
                          <div key={key}>
                            <Row md="12">
                              {item.caracterizacaoResiduosConama.grupo && (
                                <Col md="1">
                                  <p>
                                    {item.caracterizacaoResiduosConama.grupo}
                                  </p>
                                </Col>
                              )}
                              <Col
                                md={
                                  item.caracterizacaoResiduosConama.grupo
                                    ? "1"
                                    : "2"
                                }
                              >
                                <p>
                                  {item.caracterizacaoResiduosConama.codigo}
                                </p>
                              </Col>
                              {item.caracterizacaoResiduosConama?.tipo && (
                                <Col md="1">
                                  <p>
                                    {item.caracterizacaoResiduosConama?.tipo}
                                  </p>
                                </Col>
                              )}
                              <Col md="7">
                                <p>
                                  {item.caracterizacaoResiduosConama.descricao}
                                </p>
                              </Col>
                              <Col md="2">
                                <p>
                                  {item.quantidadeEstimada}{" "}
                                  {protocolo.protocoloGerador[0]
                                    .classificacaoEstabelecimento?.categoria ==
                                    "RSS"
                                    ? "Kg/dia"
                                    : "Litros/dia"}{" "}
                                </p>
                              </Col>
                            </Row>
                            <hr />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}

              {protocolo.protocoloGerador[0]
                ?.protocoloGeradorLocaisArmazenagem != null &&
                protocolo.protocoloGerador[0]?.protocoloGeradorLocaisArmazenagem
                  ?.length > 0 && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Locais de Armazenagem</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      {protocolo.protocoloGerador[0]?.protocoloGeradorLocaisArmazenagem.map(
                        (item, key) => (
                          <div key={key}>
                            <Row md="12">
                              <Col md="2">
                                <b>CEP:</b> <p>{item.cep}</p>
                              </Col>
                              <Col md="4">
                                <b>Endereço:</b>{" "}
                                <p>
                                  {item.logradouro + ", " + item.numEndereco}
                                </p>
                              </Col>
                              <Col md="4">
                                <b>Bairro:</b> <p>{item.bairro}</p>
                              </Col>
                              <Col md="2">
                                <Button
                                  color="info"
                                  type="button"
                                  onClick={() =>
                                    handleModalOpen(item.geoLocalizacao)
                                  }
                                >
                                  <i className="fas fa-map-marked-alt"></i>
                                </Button>
                              </Col>
                            </Row>
                            <hr />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}

              {!!segmentoGerador &&
                segmentoGerador !== "Grande Gerador - PGRCC" && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Locais de Coleta</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                  </Row>
                )}
              {protocolo.protocoloGerador[0]?.protocoloGeradorLocais.map(
                (item, key) => (
                  <div key={key}>
                    <Row md="12">
                      <Col md="2">
                        <b>CEP:</b> <p>{item.cep}</p>
                      </Col>
                      <Col md="4">
                        <b>Endereço:</b>{" "}
                        <p>{item.logradouro + ", " + item.numEndereco}</p>
                      </Col>
                      <Col md="3">
                        <b>Bairro:</b> <p>{item.bairro}</p>
                      </Col>
                      <Col md="3">
                        {item.geoLocalizacao != null && (
                          <Button
                            color="info"
                            type="button"
                            onClick={() => handleModalOpen(item.geoLocalizacao)}
                          >
                            <i className="fas fa-map-marked-alt"></i>
                          </Button>
                        )}
                        {item?.protocoloGeradorLocalContratos?.length > 0 && (
                          <Button
                            color="success"
                            type="button"
                            onClick={() => {
                              set_listcontratoLocal(
                                item.protocoloGeradorLocalContratos
                              );
                              set_modalContrato(true);
                            }}
                          >
                            <i className="fas fa-file-alt"></i> Contratos
                          </Button>
                        )}
                      </Col>
                    </Row>
                    <hr />
                  </div>
                )
              )}

              {protocolo.protocoloGerador[0]?.protocoloGeradorClasseResiduos.map(
                (item, key) => (
                  <div key={key}>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">Classes de Resíduo</h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row md="12">
                      <Col md="6">
                        <b>Classe:</b> <p>{item.classeResiduo.descricao}</p>
                      </Col>
                      <Col md="6">
                        <b>Quantidade Estimada (Kg):</b>{" "}
                        <p>{item.quantidadeEstimada}</p>
                      </Col>
                    </Row>
                    <hr />
                  </div>
                )
              )}

              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Documentos</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Documento", field: "documento.descricao" },
                    { title: "Arquivo", field: "arquivo" },
                  ]}
                  data={protocolo.protocoloDocumentos}
                  isLoading={false}
                  options={{
                    filtering: false,
                    exportButton: true,
                  }}
                  actions={[
                    {
                      icon: "insert_drive_file",
                      tooltip: "Visualizar Documento",
                      onClick: (event, rowData) =>
                        window.open(
                          setupSistema?.caminhoVirtual + rowData.arquivo,
                          "_blank"
                        ),
                    },
                  ]}
                  localization={table_translate}
                />
              </Row>
              <Row className="mt-4">
                <Col lg="12">
                  <h3 className="titulo-consulta">Requerimentos</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Número", field: "numeroRequerimento" },
                    { title: "Tipo", field: "setupSolicitacaoAcao.acao" },
                    {
                      title: "Etapa",
                      field: "fluxoCadastroEtapaAtual.tipo",
                      render: (rowData) =>
                        rowData.fluxoCadastroEtapaAtual != null
                          ? rowData.setupSolicitacaoAcao.setupSolicitacao
                            .categoria.sigla == "RSS" &&
                            rowData.fluxoCadastroEtapaAtual?.tipo ==
                            "Aguardando Compensação" &&
                            rowData.status == "Finalizado"
                            ? "Finalizado"
                            : rowData.fluxoCadastroEtapaAtual?.tipo
                          : "",
                    },
                    { title: "Status", field: "status" },
                    {
                      title: "Data Requerimento",
                      field: "dataCriacaoRequerimento",
                      render: (rowData) =>
                        formateDate(rowData.dataCriacaoRequerimento),
                    },
                    {
                      title: "Atualizado Em",
                      field: "dataUltimaAcao",
                      render: (rowData) =>
                        formateDateandTime(rowData.dataUltimaAcao),
                    },
                    {
                      title: "Data de Aceite",
                      field: "dataAceiteDeclaracao",
                      render: (rowData) =>
                        rowData.dataAceiteDeclaracao != null
                          ? formateDateandTime(rowData.dataAceiteDeclaracao)
                          : "",
                    },
                    {
                      title: "Data de Finalização",
                      field: "dataUltimaAcao",
                      render: (rowData) =>
                        rowData.dataUltimaAcao != null &&
                          rowData.status === "Finalizado"
                          ? formateDateandTime(rowData.dataUltimaAcao)
                          : "",
                    },
                  ]}
                  data={protocolo.requerimento.sort(function (a, b) {
                    return (
                      new Date(b.dataCriacaoRequerimento) -
                      new Date(a.dataCriacaoRequerimento)
                    );
                  })}
                  isLoading={false}
                  options={{
                    filtering: false,
                    exportButton: true,
                  }}
                  actions={[
                    {
                      icon: "insert_drive_file",
                      tooltip: "Visualizar Detalhes",
                      onClick: (event, rowData) =>
                        handleOpenRequerimento(rowData),
                    },
                    (rowData) => {
                      return (
                        (rowData.status == "Em Andamento" ||
                          rowData.status == "Divergente" ||
                          rowData.status == "Pendente") && {
                          icon: "cancel",
                          tooltip: "Cancelar Requerimento",
                          onClick: (event, rowData) =>
                            handleCancelarRequerimento(rowData),
                        }
                      );
                    },
                  ]}
                  localization={table_translate}
                />
              </Row>
              <Row className="mt-4">
                <Col lg="12">
                  <h3 className="titulo-consulta">Histórico de Alteração de E-mail</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Data/Hora", field: "dataHora", render: (rowData) => formateDateandTime(rowData.dataHora) },
                    { title: "Usuário", field: "nomeUsuario" },
                    { title: "E-mail Antigo", field: "emailAntigo" },
                    { title: "E-mail Atual", field: "emailAtual" },
                  ]}
                  data={protocolo?.protocoloHistoricoContatos}
                  isLoading={false}
                  options={{
                    filtering: false,
                    exportButton: true,
                  }}
                  localization={table_translate}
                />

              </Row>
              {modal && (
                <ModalJustificativa
                  visibilidadeModal={modal}
                  setVisibilidadeModal={toggleModal}
                  item={item}
                />
              )}
              <div className="text-center">
                {showAcoesGestor &&
                  item?.protocoloJustificativas.length > 0 && (
                    <Button color="warning" onClick={() => toggleModal()}>
                      <i className="fas fa-info mr-2"></i>
                      Justificativas Protocolo
                    </Button>
                  )}
                {showAcoesGestor == false &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente") &&
                      prop.acao == "Inclusão" &&
                      (prop.setupSolicitacao.categoria.sigla == "RCC" ||
                        prop.setupSolicitacao.categoria.sigla == "RGG")
                    ) {
                      return (
                        <Button
                          color="info"
                          onClick={() =>
                            handleRequerimentoInclusaoLocalColeta(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }

                    if (
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente") &&
                      prop.acao == "Exclusão" &&
                      (prop.setupSolicitacao.categoria.sigla == "RCC" ||
                        prop.setupSolicitacao.categoria.sigla == "RGG")
                    ) {
                      return (
                        <Button
                          color="primary"
                          onClick={() =>
                            handleRequerimentoExclusaoLocalColeta(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }

                    if (
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente" || protocolo.status == "Vencido" || protocolo.status == "Inativo") &&
                      prop.acao == "Renovação" &&
                      (prop.setupSolicitacao.categoria.sigla == "RCC" || prop.setupSolicitacao.categoria.sigla == "RGG")
                    ) {
                      return (
                        <Button
                          color="success"
                          onClick={() =>
                            handleRequerimentoRenovarCadastro(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }

                    if (
                      prop.acao == "Cancelamento" &&
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente" || protocolo.status == "Vencido" || protocolo.status == "Inativo")
                    ) {
                      return (
                        <Button
                          color="danger"
                          onClick={() => handleRequerimentoCancelamento(prop)}
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo.status == "Ativo" &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (
                      prop.acao == "Alteração" &&
                      prop.setupSolicitacao.categoria.sigla == "RSS"
                    ) {
                      return (
                        <Button
                          key={key}
                          color="warning"
                          onClick={() =>
                            handleRequerimentoAlterarCadastro(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                    if (
                      prop.acao == "Alteração" &&
                      (prop.setupSolicitacao.categoria.sigla == "RGG" ||
                        prop.setupSolicitacao.categoria.sigla == "RCC")
                    ) {
                      return (
                        <Button
                          key={key}
                          color="warning"
                          onClick={() =>
                            handleRequerimentoAlterarCadastroRCC_RGG(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }

                  })}

                {showAcoesGestor == false &&
                  protocolo.status == "Ativo" &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (
                      prop.acao == "Taxa FisLurb"
                    ) {
                      return (
                        <Button
                          key={key}
                          color="warning"
                          onClick={() =>
                            handleRequerimentoTaxaFislurb(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo.status == "Cancelado" &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (prop.acao == "Novo Cadastro") {
                      return (
                        <Button
                          color="success"
                          onClick={() => handleRequerimentoNovoCadastro(prop)}
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo?.requerimento?.filter(
                    (x) =>
                      x.status == "Pendente" &&
                      x.fluxoCadastroEtapaAtual !== null &&
                      x.fluxoCadastroEtapaAtual?.tipo?.toUpperCase() ==
                      "EMISSÃO DE GUIA"
                  ).length > 0 &&
                  setupSistema &&
                  setupSistema.metodologiaCobranca == "Integração PRODAM" && (
                    <Button
                      color="dark"
                      onClick={() =>
                        handleEmitirGuia(
                          protocolo?.requerimento?.filter(
                            (x) =>
                              x.status == "Pendente" &&
                              x.fluxoCadastroEtapaAtual !== null &&
                              x.fluxoCadastroEtapaAtual?.tipo?.toUpperCase() ==
                              "EMISSÃO DE GUIA"
                          )[0]?.requerimento_Id
                        )
                      }
                    >
                      Emitir Guia
                    </Button>
                  )}
              </div>
            </CardBody>
          </Card>

          <Modal
            centered
            isOpen={modalMapaOpen}
            toggle={() => set_modalMapaOpen(false)}
            zIndex="9999999"
          >
            <ModalBody className="md-bd">
              <h6>Localização no Mapa</h6>
              <Row className="mt-2">
                <Col lg="12">
                  <div id="map">
                    <MapContainer style={{ zIndex: "0" }}>
                      <ChangeMap center={centerMap} zoom={20}></ChangeMap>
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        opacity={0.5}
                      />
                      <Marker
                        position={positionMarker}
                        draggable={false}
                        icon={iconMarker}
                      ></Marker>
                    </MapContainer>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className="md-ft">
              <Button
                color="secondary"
                outline
                onClick={() => set_modalMapaOpen(false)}
              >
                Fechar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
      {requerimento != null && (
        <FichaRequerimento
          item={requerimento}
          handleReturn={handleReturnRequerimento}
          showAcoesGestor={showAcoesGestor}
        ></FichaRequerimento>
      )}
    </>
  );
}
